import {FC, useEffect} from "react";
import {Box, BoxProps} from "@mui/material";
import {AdminHeader} from "../../../AdminHeader";
import {IAdminUserFinishedCourses} from "../../../../../types/admin";
import {DataGridPro, GridColumns, GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid-pro";
import {useApi} from "@buildwitt/shapeshift-identity";
import {makeStyles} from "tss-react/mui";
import {CustomToolbar} from "../../../../../components/admin/bulkEnrollment/CustomToolbar";

interface ICustomProps {
	userId: number
}

export type IProps = Omit<BoxProps, "children"> & ICustomProps;

const useStyles = makeStyles()((theme) => ({
	tableRoot: {
		cursor: "default"
	}
}))

const headCells: GridColumns<IAdminUserFinishedCourses["data"][0]> = ([
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		type: "string",
		hideable: false
	},
	{
		field: "title",
		flex: 1,
		headerName: "Course",
		type: "string",
		minWidth: 240
	},
	{
		field: "dueOn",
		flex: 1,
		headerName: "Due on",
		type: "date"
	},
	{
		field: "completedAt",
		flex: 1,
		headerName: "Completed on",
		type: "date"
	},
	{
		field: "contentType",
		flex: 1,
		headerName: "Content Type",
		type: "string"
	}
])

export const UserFinishedCoursesTab:FC<IProps> = ({userId, ...baseProps}) => {
	const [rows, getRows] = useApi<IAdminUserFinishedCourses>()
	const {classes} = useStyles();

	useEffect(() => {
		getRows(`/api/user/admin/${userId}/finishedCourses`)
	}, [userId])

	return <Box {...baseProps}>
		<AdminHeader title="User's Finished Courses" />
		<Box>
			<DataGridPro<IAdminUserFinishedCourses["data"][0]>
				className={classes.tableRoot}
				initialState={{
					sorting: {
						sortModel: [{field: "completedAt", sort: "desc"}]
					}
				}}
				aria-label="admin table"
				loading={rows.isLoading}
				pagination
				keepNonExistentRowsSelected
				rowCount={rows?.data?.totalCount ?? 0}
				rows={rows?.data?.data ?? []}
				columns={headCells}
				rowsPerPageOptions={[25, 50, 100, 200]}
				components={{Toolbar: CustomToolbar}}
				checkboxSelection
				autoHeight
			/>
		</Box>


	</Box>
}
